import { FC } from "react";

import { ExperimentLayout } from "layouts/ExperimentLayout";

import { Experiment } from "features/Experiment";

const ExperimentPage: FC = () => {
  return (
    <ExperimentLayout>
      <Experiment />
    </ExperimentLayout>
  );
};

export default ExperimentPage;
